import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=6d22ec81&scoped=true&"
import script from "./ResourceTable.vue?vue&type=script&lang=js&"
export * from "./ResourceTable.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=6d22ec81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22ec81",
  null
  
)

export default component.exports